import { render, staticRenderFns } from "./TransferenciaDetalle.vue?vue&type=template&id=6367e8bc&scoped=true"
import script from "./TransferenciaDetalle.vue?vue&type=script&lang=ts"
export * from "./TransferenciaDetalle.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciaDetalle.vue?vue&type=style&index=0&id=6367e8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367e8bc",
  null
  
)

export default component.exports